import { Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { CommonService } from 'src/app/Global-Services/common.service';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AppTokenHandler } from 'src/app/Global-Services/app-token-handler';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { GlobalVariable } from 'src/app/Variable/global-variable';
import { NgModel } from '@angular/forms';


@Component({
  selector: 'app-grant-access-matrix',
  standalone: false,
  templateUrl: './grant-access-matrix.component.html',
  styleUrl: './grant-access-matrix.component.css'
})

export class GrantAccessMatrixComponent implements OnInit {

 ErrorMessage = [];
  EmployeeName: string[];
  filteredEmployeeSingle: any [] =[];
  EmployeeList = {
    Employee: null,
    EmployeeGPN: null
  };
  AccessRecordList = {
    AccessMatrixID: 0,
    EmployeeName: '',
    EmployeeGPN:'',
    ServiceLine: '',
    CountryId: '',
    CountryText: '',
    MargentSegment: '',
    ClientServingId: '',
    ClientServingText: '',
    Location: null,
    LocationtText: '',
    Competency: '',
    IsActive: true,
    CurrentUserGPN: '',
    EncryptAccessMatrixID: ''
  };
  ServiceLineList: String[];
  CountryList: String[];
  MargentSegmentList: String[];
  ClientServingList: String[];
  LocationList: String[];
  CompetencyList: String[];
  selectedOptions: string[] = [];
  isLoading: boolean =false;

 @ViewChild('txtEmployeeGPN') txtEmployeeGPN?: NgModel;

  constructor(public route: ActivatedRoute, private confirmBox: ConfirmationService,
    public gService: CommonService, public datepipe: DatePipe, private gVariable: GlobalVariable,
    private appTokenHandler: AppTokenHandler, private _Location: Location, public dialog: MatDialog, private _router: Router,
    private el: ElementRef,private cd: ChangeDetectorRef) { }


  async ngOnInit() {
    this.filteredEmployeeSingle = [];
    this.AccessRecordList.EncryptAccessMatrixID = this.route.snapshot.paramMap.get('ParamID');
    this.GetServiceLine();
    this.GetKeyWordByKeyWordType('ClientServing');
    this.GetKeyWordByKeyWordType('Country');
    await this.GetLocation();
    this.GetMarketSegmentForDropDown();
    await this.GetCompetencyForDropDown();
    this.AccessRecordList.CurrentUserGPN = this.gVariable.User.UserGPN;
    if (this.AccessRecordList.EncryptAccessMatrixID != null && this.AccessRecordList.EncryptAccessMatrixID !== '') {
      this.GetAccessRecordDataByID(this.AccessRecordList.EncryptAccessMatrixID);
    }
  }

  GetAccessRecordDataByID(ID: string)
  {
    this.isLoading = true;
    this.gService.GetAccessRecordDataByID(ID, this.AccessRecordList.CurrentUserGPN).subscribe((data: any) => {
      if (data != null) {
  this.AccessRecordList.AccessMatrixID = data[0].AccessMatrixID;
    this.AccessRecordList.EmployeeName = data[0].EmpName;
    this.AccessRecordList.EmployeeGPN =data[0].EmployeeGPN;
    this.AccessRecordList.ServiceLine = data[0].ServiceLine;
    this.AccessRecordList.CountryId = data[0].CountryId;
    this.AccessRecordList.CountryText = data[0].CountryText;
    this.AccessRecordList.MargentSegment = data[0].MarketSegmentID;
    this.AccessRecordList.ClientServingId = data[0].ClientServingId;
    this.AccessRecordList.ClientServingText = data[0].ClientServingText;
    this.AccessRecordList.Location = Number.parseInt(data[0].Location);
    this.AccessRecordList.LocationtText = data[0].LocationText;
    this.AccessRecordList.Competency = data[0].Competency == "-1" ? Number.parseInt(data[0].Competency) : data[0].Competency;
    this.AccessRecordList.IsActive = data[0].Active;

    this.filteredEmployeeSingle = [
          {
            EmpFullName: data[0].EmpName + " (" + data[0].EmpEmail + ")",
          }
        ];
        this.EmployeeList.Employee = this.filteredEmployeeSingle[0];
    }
    this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  GetEmpSearch(event: any, isGPNFilter: boolean = false) {
    const query = event.query;
    if ((query.length) >= 3) {
      this.gService.GetEmployeeSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {
        if (data!=null && data.length > 0) {
          this.filteredEmployeeSingle = data;
        } else {
          this.EmployeeName = [];
          this.filteredEmployeeSingle = [];
        }
        this.isLoading = false;
      },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }

  GetKeyWordByKeyWordType(Value: string, EmpGPN: string = '') {
    this.isLoading = true;
    this.gService.GetKeyWordByKeyWordType(Value, EmpGPN).subscribe((data: any) => {
      if (Value === 'ClientServing') {
        this.ClientServingList = data;
      }
      if (Value === 'Country') {
        this.CountryList = data;
        this.AccessRecordList.CountryId = data[0].KeyWordValue;
      }
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  async GetLocation() {
    this.isLoading = true;
    const data: any = await this.gService.GetLocation().toPromise();
    try{
      if (data != null) {
        if (data.length > 0) {
          this.LocationList = data;
        }
        this.isLoading = false;
      }
    }
    catch (error) {
      this.isLoading = false;
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      }
    }
  }

  GetMarketSegmentForDropDown() {
    this.isLoading = true;
    this.gService.GetMarketSegmentForDropDown().subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.MargentSegmentList = data;
        }
      }
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  async GetCompetencyForDropDown() {
    this.isLoading = true;
    const data: any = await this.gService.GetCompetencyForDropDown().toPromise();
      try{
      if (data != null) {
        if (data.length > 0) {
          this.CompetencyList = data;
        }
      }

      this.isLoading = false;
    }
    catch (error) {
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      }
    }
  }


  OnClearSendUser() {
    this.AccessRecordList.EmployeeName = null;
    this.AccessRecordList.EmployeeGPN = null;
  }

   SetSelectedEmpGPN(event: any) {
    this.AccessRecordList.EmployeeName = event.value.EmpName;
    this.AccessRecordList.EmployeeGPN = event.value.EmpGPN;
  }

  GetServiceLine() {
this.isLoading = true;
    this.gService.GetServiceLine().subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.ServiceLineList = data;
        }
      }
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  SubmitAccessMatrix()
  {
    this.isLoading = true;
     this.ErrorMessage = [];

     if (this.AccessRecordList.EmployeeGPN == '' || this.AccessRecordList.EmployeeGPN == null) {
      this.ErrorMessage.push({ Message: 'Please select Employee Name.' });
    }
    if (this.AccessRecordList.ServiceLine == '' || this.AccessRecordList.ServiceLine == null) {
      this.ErrorMessage.push({ Message: 'Please select ServiceLine.' });
    }
    if (this.AccessRecordList.CountryId == '' || this.AccessRecordList.CountryId == null) {
      this.ErrorMessage.push({ Message: 'Please select Country.' });
    }
    if (this.AccessRecordList.MargentSegment == '' || this.AccessRecordList.MargentSegment == null) {
      this.ErrorMessage.push({ Message: 'Please select Margent Segment.' });
    }
    if (this.AccessRecordList.ClientServingId == '' || this.AccessRecordList.ClientServingId == null) {
      this.ErrorMessage.push({ Message: 'Please select Client Serving.' });
    }
    if (this.AccessRecordList.Location == '' || this.AccessRecordList.Location == null) {
      this.ErrorMessage.push({ Message: 'Please select Location.' });
    }
    if (this.AccessRecordList.Competency == '' || this.AccessRecordList.Competency == null) {
      this.ErrorMessage.push({ Message: 'Please select Competency.' });
    }
    if(this.AccessRecordList.AccessMatrixID == 0 && this.AccessRecordList.IsActive == false)
    {
      this.ErrorMessage.push({ Message: 'Please select Is Active.' });
    }

     if (this.ErrorMessage.length > 0) {
      this.isLoading = false;
      return;
    }
    var boolReturn = false;
    boolReturn = confirm('Are you sure you want to submit this form?');
    if (boolReturn === false) {
      this.isLoading = false;
      return;
    }
    this.gService.PostService(this.AccessRecordList, 'AccessMatrix/InsertAndUpdateAccessMatrix').subscribe(data => {
      if(data == "Success")
      alert("Data Submitted Successfully!");
      this._router.navigate(['/View/ViewAccessMatrixRecordComponent']);
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  onExit()
  {
    let confirm = false;
    const message = 'Are You Sure Want to Exit.';
    confirm = window.confirm(message);

    if (confirm) {
      this._router.navigate(['/View/ViewAccessMatrixRecordComponent']);
    }
  }

  blockSpecialChar(event: any) {
    try {
      let k;

      if (event.key !== undefined) {
        k = event.key.charCodeAt(0);
      } else {
        document.all ? k = event.keyCode : k = event.which;
      }
      return ((k >= 65 && k <= 90) || (k >= 97 && k <= 122) || k === 8 || k === 32 || (k >= 48 && k <= 57) || k === 45);
    }
    catch (error) {
      console.log(error);
      return;
    }
  }

}
